<template> 
  <div class="router-front"></div>
  <div class="router">
  
  <router-view v-slot="{ Component, route }">
  <transition name="fade" mode="out-in">
    <component :is="Component" :key="route.path" />
  </transition>
</router-view>
  </div> 
  <div  class="router-backend"></div>
  </template>
  <script setup>
  import {reactive,provide,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
  import * as vueUse from "@vueuse/core";
  import Language from "@/hooks/language.js";
  import Router from "@/hooks/router.js";
  import bridge from "@/utils/sdkBridge.js";
  import * as request from "@/api/request";
  import * as utils from "@/utils";
  import * as _ from "lodash-es";
  import { useRoute } from 'vue-router';
 

 const route = useRoute();
      const { initLang ,curLang, getLangTxt, langData} = Language();

      const routerData = {};
      const compData = {};
      const PAGE_DATA_LANG = {"default":{"isLogin":true,"host":utils.getMainHost(),"pageId":"dqtw_sfcz","loginAccount":"globaltest","isBind":false,"serverName":"虚假的服","roleName":"虚假的角色","payLevel":2,"tips":"提示语提示语提示语提示语提示语提示语提示语提示语提示语提示语提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"bindPopupState":false,"infoPopupState":false,"awardContentPopupState":false,"bagPopupState":false,"nowResetType":`daily`,"myPackageList":[{create_time:"2022-09-09 23:23:23",send_value: "123456789", name:"卓越の綿服*5、卓越の玉佩*5、卓越の帳簿*5、自选宝印碎片*1、人参*1、許可書選択*1、病人手帳*3、市井手帳*15"}],"gameId":335,"payDetailMap":{
"activity":0,
"daily":0,
"lifetime":0,
"monthly":0
},"resetList":['daily','lifetime'],"awardDetail":`这是奖励详情`,"pageName":"寻道大千台湾-第三方充值活动","uid":``,"giftCodePopupState":false,"nowGiftCode":`1234567890`,"currency":`USD`,"payDetailWithCurrency":{},"awardList":[],"resetTextMap":{
"activity":"活动期间累充",
"lifetime":"终身累充",
"daily":"每日累充",
"monthly":"每月累充",
"weekly-1": "每周累充",
"weekly-2": "每双周累充",
"weekly-3": "每三周累充",
"weekly-4": "每四周累充",
},"recentServerList":[],"reset_timezone":{
   'daily': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'lifetime': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'activity': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'weekly-1': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'weekly-2': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'weekly-3': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'weekly-4': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'monthly': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
},"isEdit":true,"activityName":"寻道大千台湾-第三方充值活动"},"zh-TW":{"isLogin":true,"host":utils.getMainHost(),"pageId":"dqtw_sfcz","loginAccount":"globaltest","isBind":false,"serverName":"虚假的服","roleName":"虚假的角色","payLevel":2,"tips":"提示语提示语提示语提示语提示语提示语提示语提示语提示语提示语提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"bindPopupState":false,"infoPopupState":false,"awardContentPopupState":false,"bagPopupState":false,"nowResetType":`daily`,"myPackageList":[{create_time:"2022-09-09 23:23:23",send_value: "123456789", name:"卓越の綿服*5、卓越の玉佩*5、卓越の帳簿*5、自选宝印碎片*1、人参*1、許可書選択*1、病人手帳*3、市井手帳*15"}],"gameId":335,"payDetailMap":{
"activity":0,
"daily":0,
"lifetime":0,
"monthly":0
},"resetList":['daily','lifetime'],"awardDetail":`这是奖励详情`,"pageName":"寻道大千台湾-第三方充值活动","uid":``,"giftCodePopupState":false,"nowGiftCode":`1234567890`,"currency":`USD`,"payDetailWithCurrency":{},"awardList":[],"resetTextMap":{
"activity":"活动期间累充",
"lifetime":"终身累充",
"daily":"每日累充",
"monthly":"每月累充",
"weekly-1": "每周累充",
"weekly-2": "每双周累充",
"weekly-3": "每三周累充",
"weekly-4": "每四周累充",
},"recentServerList":[],"reset_timezone":{
   'daily': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'lifetime': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'activity': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'weekly-1': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'weekly-2': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'weekly-3': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'weekly-4': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
  'monthly': {end: "2023/01/05 08:48:41",start: "2023/05/05 08:48:41"},
},"isEdit":true,"activityName":"寻道大千台湾-第三方充值活动"}};
      const pageData = reactive(PAGE_DATA_LANG[curLang] || PAGE_DATA_LANG['zh-TW']||{});
      let pagePlatform = "global"
      let pagePlatformId = 8;

      provide("pageData", pageData);

      if(pageData.gameId!==void 0 ){
        pageData.gameId = utils.getUrlParams("gameId") ||  utils.getUrlParams("gameID") ||  utils.getUrlParams("game_id") || pageData.gameId || ""
      }

      initLang();
      // 自定义setup - 开始
      // 如果是模版，就修改一个能用的活动标识
if (/^template/.test(pageData.pageId)) {
  pageData.pageId = "fajiangvn";
}
window.activityDataLayer.push({
  eventName: "view_page",
  eventType: pageData.pageName,
  gameId: pageData.gameId,
  aid: pageData.pageId,
});


const defaultServerItem = [
  {sid: "", id: "", sname: getLangTxt("pleaseSelectServer")},
]
const defaultRoleItem = [
  {roleID: "", roleName: getLangTxt("pleaseSelectRole")},
]
const listData = reactive({
  awardList: [],
  payDetailMap: {},
})
const canClickRefresh = ref(true)
const resetData = () => {
  pageData.isEdit = false;
  pageData.isLogin = false
  pageData.loginAccount = ""
  pageData.isBind = false
  pageData.serverName = ""
  pageData.roleName = ""
  pageData.pagePayType = ""
  pageData.currency = ""
  pageData.infoPopupState = false
  pageData.bindPopupState = false
  pageData.bagPopupState = false
  pageData.tipsPopupState = false
  pageData.giftCodePopupState = false
  pageData.awardContentPopupState = false
  pageData.tips = ""
  pageData.serverList = _.cloneDeep(defaultServerItem)
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  pageData.selectServerIndex = 0
  pageData.selectRoleIndex = 0
  pageData.resetList = []
  pageData.reset_timezone = {}
}
resetData()
const init = async () => {
  let loginState = await getUserJson();
  initActivity();
};
const getUserJson = async () => {
  const link = {
    gm99: `https://passport.gm99.com/ajax/get_user_json`,
    global: `https://gpassport.${utils.getMainHost()}/center/ajax/get_user_json`,
    jp:`https://jppassport.37games.com/center/ajax/get_user_json`
  };
  let res = await request.getJSON(link[pagePlatform]);
  if (res.result == 1) {
    pageData.loginAccount = res.data.LOGIN_ACCOUNT;
    pageData.isLogin = true;
    pageData.uid = res.data.UID || res.data.USER_ID;
  }
  return res && res.result == 1;
};
const getMoneyWithUnit = (num) => {
  return num.toLocaleString(curLang) + pageData.currency
}
const handleObjectWithCurrency = (moneyObject) => {
  const keys = Object.keys(moneyObject)
  const values = Object.values(moneyObject)
  let target = {}
  keys.forEach((item,index) => {
    target[item] = getMoneyWithUnit(values[index])
  })
  return target;
}
const initActivity = async () => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=getActivityConfig`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getActivityConfig`,
    jp:`https://jpeventsapi.37games.com/activity/execute?name=${pageData.pageId}&action=getActivityConfig`
  };
  let res = await request.getJSON(link[pagePlatform], {
    params: JSON.stringify({
      language: curLang,
    }),
  });
  if (res.result == 1) {
    if (res.data.bind_data && res.data.bind_data.role_id) {
      pageData.roleName = res.data.bind_data.role_name;
      pageData.serverName = res.data.bind_data.server_name;
      pageData.isBind = true;
      try {
        window.__updatePointUploadCookie(
          "role_id",
          res.data.bind_data.role_id
        );
        window.__updatePointUploadCookie(
          "role_name",
          res.data.bind_data.role_name
        );
        window.__updatePointUploadCookie(
          "server_id",
          res.data.bind_data.server_id
        );
      } catch (error) {
      }
    }
    pageData.currency = res.data.currency;
    pageData.payDetailMap = res.data.pay_detail;
    pageData.payDetailWithCurrency = handleObjectWithCurrency(pageData.payDetailMap);
    pageData.resetList = Object.keys(res.data.reset_rule);
    pageData.nowResetType = pageData.resetList[0]
    handleResetTimeZone(res.data.reset_timezone)
    listData.awardList = res.data.reset_rule;
    window.activityDataLayer.push({
      eventName: "login",
      loginAccount: pageData.loginAccount,
      uid: pageData.uid,
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
  }
};
watch(
  () => pageData.bagPopupState,
  (value) => {
    if (!value) return;
    getPackageList();
  }
);
// 背包内容
const getPackageList = async () => {
  pageData.myPackageList = [];
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=giftHistory`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=giftHistory`,
    jp:`https://jpeventsapi.37games.com/activity/execute?name=${pageData.pageId}&action=giftHistory`
  };
  let res = await request.getJSON(link[pagePlatform], {
    params: JSON.stringify({
      language: curLang,
    }),
  });
  if (res.result == 1) {
    res.data.gifts.forEach(item => {
      let resetType = item.level_type;
      let itemLevel = item.level;
      let awardListWithType = pageData.awardList.find(i => i.reset == resetType)
      if (awardListWithType) {
        item.name = awardListWithType.level.find(j => j.levelToGetAward == itemLevel)?.giftName || '';
      }
      pageData.myPackageList.push(item);
    })
  }
};
const checkIsLogin = () => {
              if (pageData.isLogin) return true
              window.location.href = utils.getLoginUrlApi(pagePlatform, pageData.gameId, curLang)
              return false
            }

const checkIsBind = () => {
  if (pageData.isBind) return true
  pageData.bindPopupState = true
  return false
}
const showTips = (txt) => {
  pageData.tips = txt;
  pageData.tipsPopupState = true;
};
// 根据时间戳返回时间
const formatDateFromTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000)
  const MDYFormat = 'MM/DD/YYYY HH:mm:ss'
  const YMDFormat = 'YYYY/MM/DD HH:mm:ss'
  const isMDY = ['fr-FR','pt-PT'].includes(curLang)
  const targetFormat = isMDY ? MDYFormat : YMDFormat
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  const formattedDate = targetFormat
    .replace('YYYY', year)
    .replace('MM', month.toString().padStart(2, '0'))
    .replace('DD', day.toString().padStart(2, '0'))
    .replace('HH', hour.toString().padStart(2, '0'))
    .replace('mm', minute.toString().padStart(2, '0'))
    .replace('ss', second.toString().padStart(2, '0'))
  return formattedDate
}
const handleResetTimeZone = (target) => {
  Object.entries(target).forEach(item => {
    let [type, time] = item
    if (time.start && time.end) {
      pageData.reset_timezone[type] = {
        start: formatDateFromTimestamp(time.start),
        end: formatDateFromTimestamp(time.end),
      }
    }
  })
  console.log(pageData.reset_timezone)
}

provide("initActivity", initActivity);
provide("checkIsLogin", checkIsLogin)
provide("checkIsBind", checkIsBind)
provide("listData", listData);
provide("showTips", showTips)
provide("canClickRefresh", canClickRefresh);
provide("getMoneyWithUnit", getMoneyWithUnit);
provide("init", init);
      // 自定义setup - 结束


  </script>
  <style lang="scss">
    @import 'assets/common.scss';

    #u_c_TIHK120.normal span {
   display: inline-block;
}
body::-webkit-scrollbar{
      width:0;
      opacity:0;
      -webkit-overflow-scrolling: touch;
}
  </style>
  